// Libraries
import {
  TemplateRef,
  Injectable
} from '@angular/core';

/**
 * Define the options for confirmation popover component.
 */
export interface ConfirmationPopoverOptionsInterface {
  /**
   * The popover title
   */
  title?: string;
  /**
   * The popover message
   */
  message?: string;
  /**
   * The popover confirmation button text
   */
  confirmText?: string;
  /**
   * The popover cancel button text
   */
  cancelText?: string;
  /**
   * The popover confirm button type e.g. `success`, `danger` etc
   */
  confirmButtonType?: string;
  /**
   * The popover cancel button type  e.g. `success`, `danger` etc
   */
  cancelButtonType?: string;
  /**
   * The popover placement. Can be `top`, `bottom`, `left`, `right`
   */
  placement?: string;
  /**
   * Which button to cancel. Can be either `confirm` or `cancel`
   */
  focusButton?: string;
  /**
   * Whether to hide the confirmation button
   */
  hideConfirmButton?: boolean;
  /**
   * Whether to hide the cancel button
   */
  hideCancelButton?: boolean;
  /**
   * A custom CSS class to be added to the popover
   */
  popoverClass?: string;
  /**
   * Whether to append the popover to the document body
   */
  appendToBody?: boolean;
}

/**
 * Represents the options for confirmation popover component.
 */
export class ConfirmationPopoverOptions implements ConfirmationPopoverOptionsInterface {
  title: string;
  message: string;
  confirmText = 'Confirmar';
  cancelText = 'Cancelar';
  confirmButtonType = 'success';
  cancelButtonType = 'default';
  placement = 'top';
  focusButton: string;
  hideConfirmButton = false;
  hideCancelButton = false;
  popoverClass = '';
  appendToBody = false;
}

/**
 * @private
 */
@Injectable()
export class ConfirmationPopoverWindowOptions extends ConfirmationPopoverOptions {
  public onConfirm: Function;
  public onCancel: Function;
  public onAfterViewInit: Function;
  public customTemplate: TemplateRef<any>;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/confirmation-popover/confirmation-popover-options.provider.ts